<template>
  <span class="keyword-ctx" v-if="splittedText">
    <span>{{ splittedText[0] }}</span>
    <span class="mark" v-if="splittedText.length > 1">{{ keyword }}</span>
    <span v-if="splittedText[1]">{{ splittedText[1] }}</span>
  </span>
</template>

<script>
export default {
  name: "MarkedText",
  props: ['content', 'keyword'],
  data() {
    return {
      splittedText: ''
    }
  },
  created() {
    this.splittedText = this.content.split(new RegExp(this.keyword, 'gm'))
  }
}
</script>

<style scoped>
.keyword-ctx {
  font-weight: 900;
}

.mark {
  font-weight: 400 !important;
  background-color: unset !important;
  padding: 0;
}
</style>